import { Injectable } from '@angular/core';
import {SimpleUser, User} from "./user.service";
import {ProfileRequirements} from "./profile-requirements.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

export type SubjectStatus = 'ACTIVE' | 'ARCHIVED' | 'DELETED' ;

export class SimpleSubject {

  id?: string;
  code: string;
  name: string;
  year?: number;
  session?: string ;

  public constructor(code: string, name: string, year: number | undefined, session: string | undefined) {
    this.code = code ;
    this.name = name ;
    this.year = year ;
    this.session = session ;
  }
}

export class Subject extends SimpleSubject {

  status: SubjectStatus = 'ACTIVE';
  sandbox: boolean ;
  createdBy?: SimpleUser ;
  createdAt?: Date ;

  requirements: ProfileRequirements ;

  inviteCode?: string ;
  inviteMessage?: string ;

  public constructor(code: string, name: string, year: number, session: string) {
    super(code, name, year, session);

    this.requirements = new ProfileRequirements();
    this.sandbox = false ;
  }
}

@Injectable({
  providedIn: 'root'
})
export class SubjectService {

  constructor(private http: HttpClient) {
  }

  getSubjects(): Observable<Subject[]> {
    return this.http.get<Subject[]>(
      `${environment.apiHost}/subjects`,
    ) ;
  }

  getSubject(id: string): Observable<Subject> {
    return this.http.get<Subject>(
      `${environment.apiHost}/subjects/${id}`,
    ) ;
  }

  createSubject(subject:Subject): Observable<Subject> {
    return this.http.post<Subject>(
      `${environment.apiHost}/subjects`,
      subject
    ) ;
  }

  updateSubject(subject:Subject): Observable<Subject> {
    return this.http.post<Subject>(
      `${environment.apiHost}/subjects/${subject.id}`,
      subject
    ) as Observable<Subject>;
  }

  getFullSubjectName(subject: SimpleSubject) : string {

    if (subject.year && subject.session) {
      return `${subject.name} (${subject.session} ${subject.year})` ;
    } else if (subject.year) {
      return `${subject.name} (${subject.year})` ;
    } else if (subject.session) {
      return `${subject.name} (${subject.session})` ;
    } else {
      return subject.name ;
    }
  }


}
